<template>
    <div>
        <div>
            <el-table
                    ref="multipleTableRef"
                    :data="pageDataList"
                    style="width: 100%"
                    border
                    v-loading="listLoading"
            >
                <el-table-column property="createTime" label="时间"/>
                <el-table-column property="content" label="对方信息">
                    <template #default="scope">
                        <p>昵称：{{ scope.row.nickName }}<span style="color: red; margin-left: 8px;">{{ scope.row.sex == 1?'男':scope.row.sex == 2?'女':''}}</span> </p>
                        <p>UID：{{ scope.row.uid }}</p>
                        <get-plain-dialog title="手机：" :code="scope.row.phone" :uid="scope.row.uid" :type="9" :subType="0"/>
                    </template>
                </el-table-column>
                <el-table-column property="content" label="下载方式">
                    <template #default="scope">
                        <p>{{scope.row.type == 0?'金币下载':scope.row.type == 1?'vip下载':scope.row.type == 2?'vip总次数类型下载':scope.row.type == 3?'聊天蜜度下载':scope.row.type == 4?'咖啡券下载':''}}</p>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {getCopyNumPageList } from '@/api/url'
    import { getFormData } from '@/api/api'
    import ImgViewer from '@/assets/js/imageViewer'
    import GetPlainDialog from "@/components/resume/GetPlainDialog";
    import HeadImg from "../../../components/HeadImg";

    export default {
        name: "InviteDetailDialog",
        components: { HeadImg, GetPlainDialog },
        props: {
            value: Object
        },
        data() {
            return {
                id: this.value.id,

                pageDataList: [],
                currentPage: 1,
                totalRow: 0,
                pageSize: 20,
                listLoading: false,
                searchLoading: false,

            }
        },
        methods: {
            getTime(val) {
                this.startTime = val[0];
                this.endTime = val[1];
                // console.log(val)
            },
            getCheck(val) {
                this.isChecked = val
            },
            getSearchType(e) {
                this.searchType = e;
                // console.log(e)
            },
            getSearchValue(e) {
                this.searchValue = e;
                // console.log(e)
            },

            //分页
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getPage();
            },


            getPage() {
                if(isNaN(this.currentPage)) {
                    this.$message({
                        showClose: true,
                        duration: 1000,
                        message: '请提交正确的页码',
                        type: 'warning'
                    })
                } else {
                    this.searchLoading = true;
                    this.listLoading = true;
                    this.sendPageReq(this.getPageParam(this.currentPage));
                }
            },

            //页面参数
            getPageParam(page) {
                let param = {};
                param['pageNum'] = page;
                param['id'] = this.id;
                this.pageParam = param;
                return param;
            },
            // 发送页面列表请求
            sendPageReq(param) {
                getFormData(getCopyNumPageList, param).then((data) => {
                    let {msg, code } = data;
                    if(code == 200) {
                        let result = data['data'];
                        this.pageDataList = result['records'];
                        this.totalRow = result['total'];
                        this.pageSize = result['size'];
                    }else{
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: msg,
                            type: 'warning'
                        })
                    }
                    this.searchLoading = false;
                    this.listLoading = false;
                })
                    .catch((response) => {
                        this.searchLoading = false;
                        this.listLoading = false;
                    })
            },

            showImg(row) {
                let imgList = []
                imgList.push(row.headImg.headImg)
                ImgViewer.open({
                    imgList: imgList
                })
            },


        },
        mounted() {
            this.getPage();
        }
    }
</script>

<style scoped>

</style>
